const SELECTOR_CARD = ".movie-modal-card";
const SELECTOR_DIALOG = ".movie-modal";
const SELECTOR_OPEN = ".link";
const SELECTOR_CLOSE = ".close-modal";
const SELECTOR_CONTAINER = ".youtube-container";

function createIframe(youtubeId) {
	const iframe = document.createElement("iframe");
	iframe.width = "700";
	iframe.height = "400";
	iframe.src = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=1&loop=1&playlist=${youtubeId}&playsinline=1&rel=0`;
	iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
	iframe.allowFullscreen = true;
	return iframe;
}

function mountVideo(card) {
	const container = card.querySelector(SELECTOR_CONTAINER);
	if (!container) return;

	const youtubeId = container.dataset.youtubeId;
	if (!youtubeId) return;

	container.innerHTML = "";
	container.appendChild(createIframe(youtubeId));
}

function unmountVideo(card) {
	const container = card.querySelector(SELECTOR_CONTAINER);
	if (!container) return;
	container.innerHTML = "";
}

function bindCard(card) {
	if (card.dataset.modalBound === "1") return;
	card.dataset.modalBound = "1";

	const dialog = card.querySelector(SELECTOR_DIALOG);
	const openButton = card.querySelector(SELECTOR_OPEN);
	const closeButton = card.querySelector(SELECTOR_CLOSE);

	if (!dialog || !openButton || !closeButton) return;

	openButton.addEventListener("click", (e) => {
		e.preventDefault();

		if (typeof dialog.showModal === "function") {
			dialog.showModal();
		} else {
			dialog.setAttribute("open", "open");
		}

		mountVideo(card);
	});

	closeButton.addEventListener("click", (e) => {
		e.preventDefault();
		unmountVideo(card);

		if (typeof dialog.close === "function") {
			dialog.close();
		} else {
			dialog.removeAttribute("open");
		}
	});

	dialog.addEventListener("close", () => {
		unmountVideo(card);
	});
}

function initMovieModalThanks() {
	const cards = document.querySelectorAll(SELECTOR_CARD);
	if (!cards.length) return;
	cards.forEach(bindCard);
}

export function movieModalThanks() {
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initMovieModalThanks);
	} else {
		initMovieModalThanks();
	}
}
